import { CustomizationState } from '@customization/models/ColorConfig';
import { defaultLightTheme } from '@customization/themes/default';

const state: CustomizationState = {
  theme: defaultLightTheme,
};

export default state;
